import React, { useState, Fragment } from 'react';
import {Container, Card} from 'react-bootstrap'
import Busqueda360 from './busqueda-360';
import DetalleGestion360 from './detalle-gestion-360';

const Consulta360 = () => {

    const [listaDetalle, setListaDetalle]=useState([])
    const [itemSeleccionado, setItemSeleccionado]=useState({})

  return (
    <>
    <style type='text/css'>
    {`
    .btn-limpiar {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }    
    .btn-buscar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    `}
    </style>
    <Fragment>
    <Container>
      <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                    Consulta de Gestión
                </Card.Header>
                <Card.Body>
                    <Busqueda360 setListaDetalle={setListaDetalle} setItemSeleccionado={setItemSeleccionado}/>   
                    {listaDetalle && listaDetalle.length > 0 &&
                        <DetalleGestion360 listaDetalle={listaDetalle} itemSeleccionado={itemSeleccionado}/>
                    }         
                </Card.Body>
            </Card>      
        </Container>                 
    </Container>
    <style type='text/css'>
        {`
        .label {
            font-weight: bold;
            font-size: 14px;
        }
        `}
    </style>
    </Fragment>

    </>
  )
}
export default Consulta360